module.exports = __webpack_public_path__ + "img/wsq-bg-top.45cbca23.png";